import { defineStore } from 'pinia'
import beApiClient from "@/src/be-api-client";
import {APIRoute, EP, APIBaseRoute} from "@/src/endpoints";
import { handleErrors, makeRequest, loadEntity, loadPaginatedEntity } from "@/src/utils";

export const useTagStore = defineStore('tag', {
  state: ()=> {
    return {
      // lookup data
      categories: [],
      tagCategories: [],
      allCategories: []
    }
  },
  getters: {
    tagCategoryTagsList: (state) => {
      const list = [];
      if (!state.tagCategories?.data) return list;
      state.tagCategories.data.forEach((category) => {
        category.tags.forEach((tag) => {
          list.push({
            label: `${category.category_name} (${category.category_identifier}) - ${tag.name}`,
            id: `${category.id} - ${tag.id}`,
            category_id: category.id,
            tag_id: tag.id
          });
        });
      });
      return list;
    },
    getCategories() {
      return this.allCategories.map((cat) => {
        return {
          id: cat.id,
          code: cat.category_name
        }
      })
    }
  },
  actions: {
    loadPaginatedTagCategories(params) {
      return loadPaginatedEntity(this, APIRoute(EP.admin.match.tag_categories.index), 'categories',params)
    },
    loadAllTagCategories() {
      return loadEntity(this, APIRoute(EP.admin.match.tag_categories.index), 'allCategories')
    },
    loadTagCategory(id) {
      return makeRequest(beApiClient.get, APIRoute(EP.admin.match.tag_categories.show, { id: id }));
    },
    createTagCategory(payload) {
      return makeRequest(beApiClient.post, APIRoute(EP.admin.match.tag_categories.create), { tag_category: payload });
    },
    updateTagCategory(payload) {
      return makeRequest(beApiClient.patch, APIRoute(EP.admin.match.tag_categories.update, { id: payload.id }), { tag_category: payload });
    },
    disableTagCategory(tagCategoryId) {
      return makeRequest(beApiClient.put, APIRoute(EP.admin.match.tag_categories.disable, { tag_category_id: tagCategoryId }));
    },
    enableTagCategory(tagCategoryId) {
      return makeRequest(beApiClient.put, APIRoute(EP.admin.match.tag_categories.enable, { tag_category_id: tagCategoryId }));
    },


    loadReportingDisplayOptions() {
      return makeRequest(beApiClient.get, APIRoute(EP.admin.match.tag_categories.reporting_display_options));
    },
    createTag(payload) {
      return makeRequest(beApiClient.post, APIRoute(EP.admin.match.tag.create), { tag: payload });
    },
    updateTag(payload) {
      return makeRequest(beApiClient.patch, APIRoute(EP.admin.match.tag.update, { id: payload.id }), { tag: payload });
    },
    disableTag(tagId, tagCategoryId) {
      return makeRequest(beApiClient.put, APIRoute(EP.admin.match.tag.disable, { tag_id: tagId }));
    },
    enableTag(tagId, tagCategoryId) {
      return makeRequest(beApiClient.put, APIRoute(EP.admin.match.tag.enable, { tag_id: tagId }));
    },

    loadTagCategories(matchId) {
      return loadEntity(this, APIRoute(EP.matches.applied_tags.lookups.tag_categories, { match_id: matchId }), 'tagCategories');
    },
    applyTagToMatch(payload) {
      return makeRequest(beApiClient.post, APIRoute(EP.matches.applied_tags.create, { match_id: payload.match_id } ), { tag: payload });
    },
    removeTagFromMatch(id, matchId) {
      return makeRequest(beApiClient.delete, APIRoute(EP.matches.applied_tags.delete, {id: id,  match_id: matchId}));
    }
  }
});